import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./assets/css/style.css";
import "./assets/css/global.css";

import { MaterialUIControllerProvider } from "context";
import { AppWrapper } from "context/auth";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <AppWrapper>
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <App />
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </AppWrapper>
);
